  <template>
    <div>
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">Change Password</h2>
				</div>
			</div>
			<!-- eo main header -->


			<div class="main-section mgt-40">
				<div class="container">

					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator"/>

							<div class="row">
								<div class="col-lg-8">
	<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
									<div class="form-card">
										<div class="form-card-header">
											<h3>Personal Details</h3>
										</div>

										<div class="form-card-forms">
										
												<div class="row">

													<div class="col-lg-6">
														<div class="form-group">
															<label for="">
																Enter Old Password<span class="required">*</span>
															</label>
															<input type="password" class="form-control" id="oldpassword" placeholder="Old Password"
                                 data-vv-name="oldpassword"
                                 autocomplete="off"
                                 v-model="vModel.OldPassword"
                                 data-vv-as='Old password'
                                 v-validate="'required'"
                                 :class="{'input': true, 'is-danger': errors.has('oldpassword') }"/>
																<div v-show="errors.has('oldpassword')"
																		 class="help is-danger">
																	{{ errors.first('oldpassword') }}
																</div>
                    </div>
													</div>

												</div>

												<div class="row">

													<div class="col-lg-6">
														<div class="form-group">
															<label for="">
																Enter New Password<span class="required">*</span>
															</label>
															<password-input :inputplaceholder="'New Password'" data-vv-as='New password'
																				 v-model="vModel.NewPassword" v-validate="{required : true,validatePassword : true}"
																				 :inputname="'NewPassword'"
																				 name="NewPassword"
																				 :inputclass="{'form-control input': true, 'is-danger': errors.has('NewPassword') }"
																				></password-input>
															<div v-show="errors.has('NewPassword')"
																	 class="help is-danger">
																{{ errors.first('NewPassword') }}
															</div>
                    </div>
													</div>

												</div>

												<div class="row">

													<div class="col-lg-6">
														<div class="form-group">
															<label for="">
																Confirm New Password<span class="required">*</span>
															</label>
															<input autocomplete="off" placeholder="Confirm Password"
												 v-model="vModel.ConfirmPassword"
												 v-validate="'required|confirmed:NewPassword'"
												 :class="{'input': true, 'is-danger': errors.has('Password_Confirmation') }"
												 type="password" class="form-control"
											 data-vv-name="Password_Confirmation" data-vv-as="Password" />

															<div v-show="errors.has('Password_Confirmation')" class="help is-danger">{{ errors.first('Password_Confirmation') }}</div>

														</div>
													</div>

												</div>
											
										</div>
										<!-- eo form card forms -->
									</div>
									<!-- eo form card -->

									<div class="submit-option">
										<div class="left-option">
											<router-link :to="'/dashboard'" class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="material-icons">chevron_left</i>
												</span>
												<span class="btn-content">Cancel</span>
											</router-link>
										</div>

										<div class="right-option">
											<button class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="material-icons">check</i>
												</span>
												<span class="btn-content">Save Password</span>
											</button>
										</div>
									</div>
	</form>
								</div>
								<!-- eo col-8 -->

								<div class="col-lg-4">
									<UserDetailSection/>
								</div>
							</div>
							<!-- eo row -->

						</div>
					<!-- eo main card -->

				</div>
				<!-- eo container -->
			</div>
			<!-- eo main section -->
    </div>

  </template>
  <script>
    
    import Base from "../../shared/Base.vue";
    import CommonService from "../../services/common";
    import PasswordInput from "../../shared/PasswordInput";
		import UserDetailSection from '../../shared/UserDetailSection.vue'

    export default {
      name: "ChangePassword",
      extends: Base,
      components: { PasswordInput,UserDetailSection },
      beforeRouteEnter(to, from, next) {
        next();
      },
      methods: {
        onSubmit() {
          var self = this;
          if (self.isProcessing) return;

          self.$validator.validateAll().then(result => {
            if (result) {
              var url = 'account/changepassword';
              self.isProcessing = true;
              self.$http.post(url, self.vModel).then(
                response => {
                  
                  self.$toastr("success", "Password changed successfully");
                  self.isProcessing = false;

                  if (window._sessionInterval != null) {
                    clearInterval(window._sessionInterval)
                  }
                  
                  CommonService.destroyStorage();
                  self.$router.push("/account/login")
                },
                error => {
                  self.isProcessing = false;
                }
              );
            }
          });
        },
      },
      data() {
        return {
          vModel: {
            OldPassword: null,
            NewPassword: null,
            ConfirmPassword: null
          }
        };
      }
    };
  </script>
